import { isImpersonation, removeImpersonation, activeUser, userManager } from '../Auth';
import { Ab } from '../interfaces/abTypes';
import { ByggsokEventType } from '../utils/ByggsokEventType';

const authServer = process.env.REACT_APP_SECURITY_SERVER;

async function fetchUserInfo(token: string): Promise<Response> {
  return fetch(`${authServer}/connect/userinfo`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    redirect: "manual",
    credentials: 'same-origin'
  });
}

export const fetchUser = async (): Promise<Ab.User> => {
  const user = await activeUser();
  const token = user?.access_token;

  if (!token) throw new Error("Ingen token tilgjengelig");

  let response = await fetchUserInfo(token);

  if (response.status === 401) {
    if (isImpersonation()) {
      console.warn("Impersonation token expired. Reverting to admin user.");
      alert("Adminpålogging har utløpt. Du returneres til din egen bruker.");
      removeImpersonation();
      // Optional: Reload to re-trigger auth context and UI
      window.location.reload();
      throw new Error("Impersonationexpired");
    } else {
      console.warn("User token expired. Attempting silent sign-in...");

      try {
        const renewedUser = await userManager.signinSilent();
        const renewedToken = renewedUser?.access_token;
        if (!renewedToken) throw new Error("Ingen ny token etter silent signin");

        response = await fetchUserInfo(renewedToken);
        if (!response.ok) throw response;
        return await response.json();
      } catch (renewalError) {
        console.error("Silent token renewal failed:", renewalError);

        const event = new CustomEvent("byggsokEvent", {
          detail: ByggsokEventType.LOGG_INN_PAA_NYTT
        });
        document.dispatchEvent(event);
        throw new Error("Token renewal failed, redirecting to login");
      }
    }
  }

  if (!response.ok) {
    throw new Error(`Feil ved henting av bruker: ${response.statusText}`);
  }

  return response.json();
};
